export default {
  path: 'orders-invoices',
  name: 'publisher/orders-invoices',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "publisher-show-orders-invoices" */ './OrdersInvoices')
}
